import React from "react";

const IssueMessageTemplate = ({ forSMS }) => (
  <section className="messageTemplate">
    <p>
      Below is the template for Email being sent from the Issues Listing page.
    </p>
    <b>Dear Sir/Ma'am,</b>
    <br />
    <p className="message">
      <br />
      <i>
        The message that you would enter in the message box will be reflected
        here.
      </i>
    </p>
    <br />
    Projects & Issues List:
    {forSMS ? (
      <ul>
        <li>#{`<IssueID>: <IssueTitle>`}</li>
        <li>#{`<IssueID>: <IssueTitle>`}</li>
      </ul>
    ) : (
      <ul>
        <li>#{`<ProjectID>: <ProjectTitle>`}</li>
        <li className="space-left">#{`<IssueID>: <IssueTitle>`}</li>
        <li className="space-left">#{`<IssueID>: <IssueTitle>`}</li>
      </ul>
    )}
    <p>For any queries, please write to pmg@investindia.org.in.</p>
    <p>
      Warm Regards,
      <br />
      PMG Team
      <br />
      https://pmg.dpiit.gov.in
    </p>
  </section>
);

export { IssueMessageTemplate };
